// Import Third-party libraries
import axios from 'axios'

// Function to query agent's approved email ID
export const queryAgentEmail = (
  email_id,
  environment,
  is_trial,
  dispatch,
  agentData,
) => {
  let data = { email_id, env: environment, is_trial: is_trial }
  return new Promise((resolve, reject) => {
    axios
      .post(
        'https://hal-cos-prd-gwc-fnapp-v1.azurewebsites.net/api/verifyemailid',
        data,
      )
      .then((response) => {
        let res = response.data
        if (res.status) {
          // Step 1: Extract Distributor details
          dispatch({ type: 'DISTRIBUTOR_ID', payload: res['distributor_id'] })
          const resolvedStoreId = Array.isArray(res['store_id'])
            ? res['store_id'][0]
            : res['store_id']
          dispatch({ type: 'STORE_ID', payload: resolvedStoreId })

          const resolvedAgentId =
            res.agent_id ?? res.agentID ?? res.agentId ?? res.AgentID
          dispatch({ type: 'SET_AGENT_ID', payload: resolvedAgentId })

          const mergedAgentData = {
            ...agentData,
            ...res,
            agent_id: resolvedAgentId,
            plan: res.subscription_plan ?? agentData.subscription_plan,
            status: 'User',
          }

          dispatch({
            type: 'SET_AGENT_DATA',
            payload: mergedAgentData,
          })
          resolve(res) //  Resolve on success
        } else {
          reject(new Error('Verification failed')) // Reject in "else" case
        }
      })
      .catch((err) => {
        reject(err) // Reject on API failure
      })
  })
}
